import React, { useEffect, useRef, useState } from 'react';
import Modal from '../ui/Modal';
import { registerPhotoSafetyPrompt } from '../../services/photoSafetyConsent';

export default function PhotoSafetyConsent() {
  const pending = useRef<Array<(allowed: boolean) => void>>([]);
  const [count, setCount] = useState(0);
  useEffect(() => {
    const queue = pending.current;
    const unregister = registerPhotoSafetyPrompt(() => new Promise(resolve => {
      pending.current.push(resolve);
      setCount(pending.current.length);
    }));
    return () => {
      unregister();
      queue.splice(0).forEach(resolve => resolve(false));
    };
  }, []);
  const finish = (allowed: boolean) => {
    pending.current.shift()?.(allowed);
    setCount(pending.current.length);
  };
  return <Modal isOpen={count > 0} onClose={() => finish(false)} title="Check this photo before uploading?">
    <div className="space-y-4 p-4 text-zinc-300">
      <p>With your permission, Bilt:Spec will send this photo to OpenAI to check for sexual, violent, or self-harm content before it can be published. The check uses a resized copy with file metadata removed.</p>
      <p>Only upload photos you have permission to share. Avoid private or sensitive information. If you cancel, this photo stays on your device. A flagged photo or an unavailable check stops the upload.</p>
      <p><a className="underline" href="/privacy" target="_blank" rel="noreferrer">Read our privacy policy</a></p>
      <div className="flex flex-wrap gap-3">
        <button type="button" className="btn-secondary" onClick={() => finish(false)}>Cancel upload</button>
        <button type="button" className="btn-primary" onClick={() => finish(true)}>Allow check and upload</button>
      </div>
    </div>
  </Modal>;
}
